module.exports = __webpack_public_path__ + "img/crlv.89cbacf4.png";